import {Component, Input, OnInit} from '@angular/core';
import {PropertiesService} from '../../services/api/properties-service.service';
import {AlertService} from '../../services/notify/alert.service';
import {ValuePropertyModel} from '../../models/property.model';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-file-options',
    templateUrl: './file-options.component.html',
    styleUrls: ['./file-options.component.scss']
})
export class FileOptionsComponent implements OnInit {
    @Input() public visibleHeader = true;

    tab: 'folder' | 'collection' | 'file' = 'folder';

    customProperties: ValuePropertyModel[];

    constructor(
        protected propertiesService: PropertiesService,
        protected alertService: AlertService,
        protected translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        this.getProperties(this.tab, true);
    }


    getProperties(newTab: 'folder' | 'collection' | 'file', refresh = false): void {
        if (this.tab === newTab && !refresh) {
            return;
        }

        this.tab = newTab;
        this.customProperties = undefined;
        this.propertiesService.getConnectedDocProperty(this.tab).subscribe({
            next: res => {
                this.customProperties = res.properties;
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    saveProp(newProp: ValuePropertyModel[]): void {
        const saveData = [];

        newProp.forEach(prop => {
            const elem = {
                property_default_view: prop.default_view,
                property_id: prop.property.id,
            };
            saveData.push(elem);
        });

        this.propertiesService.addOrDeletePropertyInDoc(this.tab, saveData).subscribe({
            next: () => {
                this.getProperties(this.tab, true);
                this.alertService.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }
}
